/**
 * Bahasa Malaysia translations for Open E Masjid
 *
 * Note: Prayer time names use standard Bahasa Malaysia Islamic terminology:
 * - Subuh (not Fajr)
 * - Syuruk (not Sunrise)
 * - Zohor (not Dhuhr)
 * - Asar (not Asr)
 * - Maghrib (same)
 * - Isyak (not Isha)
 */
export const ms = {
    common: {
        loading: "Memuatkan...",
        error: "Ralat",
        success: "Berjaya",
        save: "Simpan",
        cancel: "Batal",
        delete: "Padam",
        edit: "Edit",
        create: "Cipta",
        update: "Kemas Kini",
        submit: "Hantar",
        back: "Kembali",
        next: "Seterusnya",
        previous: "Sebelumnya",
        search: "Cari",
        filter: "Tapis",
        filters: "Tapisan",
        clear: "Kosongkan",
        yes: "Ya",
        no: "Tidak",
        confirm: "Sahkan",
        view: "Lihat",
        close: "Tutup",
        home: "Laman Utama",
        welcome: "Selamat Datang",
        manage: "Urus",
        add: "Tambah",
        actions: "Tindakan",
    },
    prayer: {
        times: "Waktu Solat",
        fajr: "Subuh",
        sunrise: "Syuruk",
        dhuhr: "Zohor",
        asr: "Asar",
        maghrib: "Maghrib",
        isha: "Isyak",
        current: "Waktu Solat Sekarang",
        next: "Waktu Solat Seterusnya",
        countdown: "Kira Detik",
        schedule: "Jadual Waktu Solat",
        updated: "Dikemas Kini",
        source: "Sumber",
    },
    masjid: {
        name: "Masjid",
        masjids: "Masjid-Masjid",
        location: "Lokasi",
        address: "Alamat",
        contact: "Hubungi",
        about: "Tentang",
        facilities: "Kemudahan",
        events: "Acara",
        announcements: "Pengumuman",
        browse: "Cari Masjid",
        my_masjids: "Masjid Saya",
        create: "Cipta Masjid",
        total: "Jumlah Masjid",
    },
    content: {
        title: "Kandungan",
        create: "Cipta Kandungan",
        upload: "Muat Naik Kandungan",
        my_content: "Kandungan Saya",
        pending: "Menunggu",
        approved: "Diluluskan",
        rejected: "Ditolak",
        submitted: "Dihantar",
        type: "Jenis",
        image: "Imej",
        video: "Video",
        youtube: "YouTube",
        duration: "Tempoh",
        status: "Status",
    },
    profile: {
        title: "Profil",
        my_profile: "Profil Saya",
        edit: "Edit Profil",
        name: "Nama",
        email: "E-mel",
        phone: "Nombor Telefon",
        language: "Bahasa Pilihan",
        settings: "Tetapan",
        account: "Akaun",
    },
    admin: {
        dashboard: "Papan Pemuka",
        admin_dashboard: "Papan Pemuka Pentadbir",
        approvals: "Kelulusan",
        pending_approvals: "Kelulusan Tertangguh",
        users: "Pengguna",
        registered_users: "Pengguna Berdaftar",
        content_management: "Pengurusan Kandungan",
        display_management: "Pengurusan Paparan",
        applications: "Permohonan",
        admin_applications: "Permohonan Pentadbir",
        settings: "Tetapan",
        manage_displays: "Urus Paparan",
        manage_content: "Urus Kandungan",
    },
    display: {
        title: "Paparan",
        configuration: "Konfigurasi",
        status: "Status",
        online: "Dalam Talian",
        offline: "Luar Talian",
        last_updated: "Kemas Kini Terakhir",
        brightness: "Kecerahan",
        volume: "Kelantangan",
        orientation: "Orientasi",
    },
    auth: {
        login: "Log Masuk",
        logout: "Log Keluar",
        register: "Daftar",
        forgot_password: "Lupa Kata Laluan",
        reset_password: "Tetapkan Semula Kata Laluan",
        email: "E-mel",
        password: "Kata Laluan",
        confirm_password: "Sahkan Kata Laluan",
    },
    validation: {
        required: "Medan ini diperlukan",
        invalid_email: "Alamat e-mel tidak sah",
        invalid_phone: "Nombor telefon tidak sah",
        min_length: "Panjang minimum ialah {{min}} aksara",
        max_length: "Panjang maksimum ialah {{max}} aksara",
        password_mismatch: "Kata laluan tidak sepadan",
    },
    messages: {
        save_success: "Berjaya disimpan",
        save_error: "Gagal menyimpan",
        delete_success: "Berjaya dipadam",
        delete_error: "Gagal memadam",
        update_success: "Berjaya dikemas kini",
        update_error: "Gagal mengemas kini",
        create_success: "Berjaya dicipta",
        create_error: "Gagal mencipta",
    },
    date: {
        today: "Hari Ini",
        yesterday: "Semalam",
        tomorrow: "Esok",
        week: "Minggu",
        month: "Bulan",
        year: "Tahun",
    },
    nav: {
        home: "Laman Utama",
        masjids: "Masjid-Masjid",
        my_profile: "Profil Saya",
        my_content: "Kandungan Saya",
        create_content: "Cipta Kandungan",
        admin_dashboard: "Papan Pemuka Pentadbir",
        manage_applications: "Urus Permohonan",
        manage_displays: "Urus Paparan",
        manage_content: "Urus Kandungan",
        user_approvals: "Kelulusan Pengguna",
        settings: "Tetapan",
        notifications: "Pemberitahuan",
        logout: "Log Keluar",
        profile: "Profil",
    },
    home: {
        welcome: "Selamat Datang ke Open E Masjid",
        subtitle: "Platform pengurusan masjid moden untuk komuniti Malaysia",
        quick_stats: "Statistik Pantas",
        quick_actions: "Tindakan Pantas",
        recent_activity: "Aktiviti Terkini",
        no_activity: "Tiada aktiviti terkini untuk dipaparkan.",
        complete_profile: "Lengkapkan Profil Anda",
        complete_profile_desc: "Lengkapkan tetapan profil anda untuk manfaat maksimum Masjid Suite. Tambah nombor telefon, alamat, dan pilih masjid utama anda.",
        view_edit_info: "Lihat dan edit maklumat peribadi anda",
        discover_masjids: "Cari masjid di kawasan anda",
        manage_apps_users: "Urus permohonan dan pengguna",
        add_new_masjid: "Tambah masjid baharu ke sistem",
    },
    masjidList: {
        title: "Direktori Masjid",
        subtitle: "Cari dan temui pusat Islam di Malaysia",
        add_masjid: "Tambah Masjid",
        search_placeholder: "Cari mengikut nama, penerangan, atau bandar",
        search_label: "Cari masjid",
        filter_state: "Tapis mengikut Negeri",
        clear_filters: "Kosongkan Tapisan",
        no_results: "Tiada masjid dijumpai",
        no_results_desc: "Cuba laraskan carian atau tapisan anda",
        create_first: "Cipta masjid pertama anda",
        no_masjids: "Tiada Masjid Dijumpai",
        no_masjids_desc: "Jadilah yang pertama menambah masjid ke direktori kami.",
        view_details: "Lihat Butiran",
        city: "Bandar",
        state: "Negeri",
        contact: "Hubungi",
        loading: "Memuatkan masjid...",
        error_load: "Gagal memuatkan masjid",
        all_states: "Semua Negeri",
        showing_count: "Menunjukkan {{filtered}} daripada {{total}} masjid",
        add_first: "Tambah Masjid Pertama",
        no_description: "Tiada penerangan tersedia.",
        administrators: "Pentadbir",
    },
    myContent: {
        title: "Kandungan Saya",
        subtitle: "Urus dan jejak penghantaran kandungan anda",
        create_new: "Cipta Kandungan Baharu",
        filter_status: "Tapis mengikut Status",
        refresh: "Muat Semula Kandungan",
        all_status: "Semua Status",
        loading: "Memuatkan kandungan anda...",
        error_load: "Gagal memuatkan kandungan",
        no_content: "Tiada kandungan dihantar lagi",
        no_filtered_content: "Tiada kandungan {{status}} dijumpai",
        no_content_desc: "Mulakan dengan mencipta penghantaran kandungan pertama anda.",
        no_filtered_desc: "Cuba tukar tapisan untuk melihat kandungan dengan status lain.",
        create_content: "Cipta Kandungan",
        duration_label: "Tempoh {{duration}}s",
        duration_help: "Tempoh paparan dalam saat (5-300)",
        date_range: "{{start}} - {{end}}",
        submitted_to: "Dihantar ke: {{masjid}}",
        submitted_on: "Dihantar: {{date}}",
        status_rejected: "Kandungan ini ditolak. Anda boleh hantar semula dengan pengubahsuaian.",
        status_active: "Kandungan ini telah diluluskan dan aktif.",
        preview_content: "Pratonton Kandungan",
        edit: "Edit",
        resubmit: "Hantar Semula",
        delete: "Padam",
        resubmit_title: "Hantar Semula Kandungan",
        resubmit_desc: "Buat sebarang perubahan yang diperlukan sebelum menghantar semula kandungan anda untuk kelulusan.",
        edit_title: "Edit Kandungan",
        edit_desc: "Kemaskini maklumat kandungan anda. Perubahan akan mengekalkan status kelulusan semasa.",
        delete_title: "Padam Kandungan",
        delete_warning: "Tindakan ini tidak boleh dibatalkan!",
        delete_confirm: "Adakah anda pasti mahu memadam kandungan ini?",
        delete_confirm_btn: "Ya, Padam",
        save_changes: "Simpan Perubahan",
        title_field: "Tajuk",
        description_field: "Penerangan (pilihan)",
        duration_field: "Tempoh (saat)",
        start_date: "Tarikh Mula",
        end_date: "Tarikh Tamat",
        cancel: "Batal",
        resubmit_approval: "Hantar Semula untuk Kelulusan",
        status_pending: "Menunggu",
        status_active_label: "Aktif",
        status_rejected_label: "Ditolak",
        status_expired: "Tamat Tempoh",
        type_image: "Imej",
        type_youtube: "YouTube",
        qr_code_title: "Tetapan Kod QR",
        qr_code_enabled: "Papar Kod QR",
        qr_code_url: "URL Kod QR (pilihan)",
        qr_code_url_help: "Biarkan kosong untuk menggunakan halaman kandungan lalai",
        qr_code_position: "Kedudukan Kod QR",
        qr_position_tl: "Atas Kiri",
        qr_position_tr: "Atas Kanan",
        qr_position_bl: "Bawah Kiri",
        qr_position_br: "Bawah Kanan",
    },
};
//# sourceMappingURL=ms.js.map